// University of North Texas's undergraduate majors (#2839). Read on
// 2026-10-01 from the official 2026-2027 Undergraduate Catalog's "Degree
// Programs Listed by Academic Unit" page (catalog.unt.edu, catoid=40,
// navoid=4658; read in a headless browser because the catalog answers plain
// requests with an empty 202). Every line under a "Majors" heading is kept,
// grouped by the college or school (the page's top-level units) that
// administers it; departments are folded into their college. Grad Track
// Options, Dual Degrees, minors, certificates and the Honors College's
// requirements are left out. The catalog writes "Name, DEGREE"; the degree
// moves to `degree` and any text after it (a concentration, a teacher
// certification track) stays in the name. The catalog's en dashes
// ("non-teacher", "Choral-Keyboard") are written as hyphens; everything
// else, including the accented e in "Furnishings and Decor", is the catalog's own spelling.
// "Applied Arts and Sciences with a concentration in Public Safety" is an
// official name kept as written (#2763).
const majors = {
    "slug": "university-of-north-texas",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UNT's official 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Concentrations the catalog lists as their own programs are kept. Minors, certificates, grad track options and graduate programs are left out.",
    "groups": [
        {
            "name": "G. Brint Ryan College of Business",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Bachelor of Business Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Business Integrated Studies - International Track",
                    "degree": "BBA"
                },
                {
                    "name": "Business Integrated Studies",
                    "degree": "BBA"
                },
                {
                    "name": "General Business",
                    "degree": "BS"
                },
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Accounting",
                    "degree": "BS",
                    "note": "Dual degree; may not be earned without completion of the MS"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Financial Planning",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate with a concentration in Residential Property Management",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "BBA"
                },
                {
                    "name": "Applied Project Design and Analysis",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BBA"
                },
                {
                    "name": "Business Computer Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Project Design and Analysis",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship and Enterprise Management",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Sport Entertainment Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing with a concentration in Professional Selling",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Industrial Distribution",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Merchandising and Hospitality Management",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Event Design and Experience Management",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management (Hospitality, Nutrition and Food Science teacher certification)",
                    "degree": "BS"
                },
                {
                    "name": "Digital Business and E-commerce",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies in Consumer Insights",
                    "degree": "BS"
                },
                {
                    "name": "Merchandising with a concentration in Fashion Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Merchandising with a concentration in Furnishings and Décor",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Human Development and Family Science with a concentration in Individual and Family Development across the Lifespan (non-teacher certification)",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science with a concentration in Community and Family Services (non-teacher certification)",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science (teacher certification)",
                    "degree": "BS"
                },
                {
                    "name": "Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical and Energy Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BSET"
                }
            ]
        },
        {
            "name": "College of Information",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Learning Technologies",
                    "degree": "BAS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Social Sciences",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Applied Arts and Sciences",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Applied Geography and GIS",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Applied Heritage Management",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Applied Professional Practices",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Applied Project Design",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Aviation Operations",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Computer Science",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Consumer Insights",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Data Analytics",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Digital Business and E-commerce",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Enology and Brewing",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Global Societies and GIS",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Homeland Security",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Hospitality Services",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Industrial Distribution",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Information Technology",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Leadership Development",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Logistical Operations",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Natural Hazards and Geography GIS",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Organizations and Supervision",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Public Health Education and Practice",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Public Safety",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Recreation and Sport Leadership",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Residential Property Management",
                    "degree": "BAAS"
                },
                {
                    "name": "Applied Arts and Sciences with a concentration in Workforce and Technical Administration",
                    "degree": "BAAS"
                },
                {
                    "name": "Game Studies and Design",
                    "degree": "BS"
                },
                {
                    "name": "Integrative Studies",
                    "degree": "BA"
                },
                {
                    "name": "Integrative Studies",
                    "degree": "BS"
                },
                {
                    "name": "Social Science (Social Studies teacher certification)",
                    "degree": "BS"
                },
                {
                    "name": "Social Science",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Theatre with a concentration in Acting",
                    "degree": "BA"
                },
                {
                    "name": "Theatre with a concentration in Dance",
                    "degree": "BA"
                },
                {
                    "name": "Theatre with a concentration in Design/Tech",
                    "degree": "BA"
                },
                {
                    "name": "Theatre with a concentration in Theatre Studies",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BSECO"
                },
                {
                    "name": "English with a concentration in Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English with a concentration in Language Arts",
                    "degree": "BA"
                },
                {
                    "name": "English with a concentration in Literature",
                    "degree": "BA"
                },
                {
                    "name": "English with a concentration in Writing and Rhetoric",
                    "degree": "BA"
                },
                {
                    "name": "Geographic Information Systems and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Geography with a concentration in Earth Systems",
                    "degree": "BS"
                },
                {
                    "name": "Geography with a concentration in Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Converged Broadcast Media",
                    "degree": "BA"
                },
                {
                    "name": "Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "International Studies with a concentration in Business and Economics",
                    "degree": "BA"
                },
                {
                    "name": "International Studies with a concentration in Global Conflict",
                    "degree": "BA"
                },
                {
                    "name": "International Studies with a concentration in Global Perspectives",
                    "degree": "BA"
                },
                {
                    "name": "International Studies with a concentration in Human Security",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Sociology with a concentration in Sports Culture",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Content Strategy",
                    "degree": "BA"
                },
                {
                    "name": "Technical Communication",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Advertising and Brand Strategy",
                    "degree": "BS"
                },
                {
                    "name": "Journalism with a concentration in Digital Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Journalism with a concentration in Photojournalism",
                    "degree": "BA"
                },
                {
                    "name": "Journalism with a concentration in Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Journalism with a concentration in Sports Journalism and Communications",
                    "degree": "BA"
                },
                {
                    "name": "Journalism with a concentration in Video, Broadcast and Multimedia",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Music",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Commercial Music",
                    "degree": "BA"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Critical Studies in Music and Society",
                    "degree": "BA"
                },
                {
                    "name": "Jazz Studies (instrumental, arranging or vocal emphasis)",
                    "degree": "BM"
                },
                {
                    "name": "Music Education (Specialization: Choral-Keyboard or Guitar)",
                    "degree": "BM"
                },
                {
                    "name": "Music Education (Specialization: Choral-Vocal)",
                    "degree": "BM"
                },
                {
                    "name": "Music Education (Specialization: Instrumental-Band, Woodwinds, Brass or Percussion)",
                    "degree": "BM"
                },
                {
                    "name": "Music Education (Specialization: Instrumental-Band/Orchestra)",
                    "degree": "BM"
                },
                {
                    "name": "Music Education (Specialization: Instrumental-Elementary)",
                    "degree": "BM"
                },
                {
                    "name": "Music Education (Specialization: Instrumental-Orchestra)",
                    "degree": "BM"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Performance (specialization: Harpsichord)",
                    "degree": "BM"
                },
                {
                    "name": "Performance (specialization: Orchestral Instruments - Multiple Woodwinds)",
                    "degree": "BM"
                },
                {
                    "name": "Performance (specialization: Orchestral Instruments)",
                    "degree": "BM"
                },
                {
                    "name": "Performance (specialization: Organ)",
                    "degree": "BM"
                },
                {
                    "name": "Performance (specialization: Organ, Church Music Emphasis)",
                    "degree": "BM"
                },
                {
                    "name": "Performance (specialization: Piano)",
                    "degree": "BM"
                },
                {
                    "name": "Performance (specialization: Voice)",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "College of Public Affairs and Health Sciences",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Audiology and Speech-Language Pathology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Behavior Analysis",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Emergency Administration and Planning",
                    "degree": "BS"
                },
                {
                    "name": "Health Behavior and Fitness",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology with a concentration in Pre-PT/Allied Health",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology with a concentration in Strength and Conditioning",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology (General track)",
                    "degree": "BS"
                },
                {
                    "name": "Recreation, Event and Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Nonprofit Leadership Studies",
                    "degree": "BA"
                },
                {
                    "name": "Urban Policy and Planning",
                    "degree": "BA"
                },
                {
                    "name": "Addiction Studies",
                    "degree": "BS"
                },
                {
                    "name": "Public Health with a concentration in Health Professions",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Rehabilitation Studies",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Biochemistry with a concentration in Forensic Science",
                    "degree": "BSBC"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BSBC"
                },
                {
                    "name": "Biology with a concentration in Forensic Science",
                    "degree": "BSBIO"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BSBIO"
                },
                {
                    "name": "Ecology for Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "BSMLS"
                },
                {
                    "name": "Chemistry with a Concentration in Computational Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry with a concentration in Forensics",
                    "degree": "BSCHM"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BSCHM"
                },
                {
                    "name": "Mathematics with a concentration in Computer Science",
                    "degree": "BSMTH"
                },
                {
                    "name": "Mathematics (non-teacher certification)",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics (teacher certification)",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics (non-teacher certification)",
                    "degree": "BSMTH"
                },
                {
                    "name": "Mathematics (teacher certification)",
                    "degree": "BSMTH"
                },
                {
                    "name": "Physics with a concentration in Astrophysics",
                    "degree": "BSPHY"
                },
                {
                    "name": "Physics with a concentration in Computational Physics",
                    "degree": "BSPHY"
                },
                {
                    "name": "Physics with a concentration in Engineering Physics",
                    "degree": "BSPHY"
                },
                {
                    "name": "Physics",
                    "degree": "BSPHY"
                }
            ]
        },
        {
            "name": "College of Visual Arts and Design",
            "source": {
                "label": "UNT 2026-2027 Undergraduate Catalog, Degree Programs Listed by Academic Unit",
                "url": "https://catalog.unt.edu/content.php?catoid=40&navoid=4658"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Art and Design Studies with a concentration in Arts Management",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Art and Design Studies with a concentration in Design Management",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Art and Design Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Communication Design with a concentration in Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Communication Design with a concentration in User-Experience Design",
                    "degree": "BFA"
                },
                {
                    "name": "Fashion Design",
                    "degree": "BFA"
                },
                {
                    "name": "Interior Design",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in Ceramics",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in Drawing and Painting",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in Metalsmithing and Jewelry",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in New Media Art",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in Photography",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in Printmaking",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art with a concentration in Sculpture",
                    "degree": "BFA"
                }
            ]
        }
    ]
};

export default majors;
